import { render } from "./PrizesAlternating.vue?vue&type=template&id=078ac79e&scoped=true"
import script from "./PrizesAlternating.vue?vue&type=script&lang=js"
export * from "./PrizesAlternating.vue?vue&type=script&lang=js"

import "./PrizesAlternating.vue?vue&type=style&index=0&id=078ac79e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078ac79e"]])

export default __exports__